module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMiIgaGVpZ2h0PSIyMDUiIHZpZXdCb3g9IjAgMCAyIDIwNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xIDFMMS4wMDAwMSAyMDQiIHN0cm9rZT0iI0NEQ0RDRCIgc3Ryb2tlLXdpZHRoPSIxLjM2NTI3IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./static/image/gtc-vertical-line-customization.svg
// module id = qi86
// module chunks = 1